import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { SITE } from "@/config/site";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({ title, description, path, image }) {
  const { lang } = useLanguage();
  useEffect(() => {
    const url = `${SITE.canonicalBase}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE.name);
    setMeta("property", "og:locale", lang === "fr" ? "fr_FR" : "en_US");
    const ogImagePath = image ? image[lang] || image.fr : lang === "en" ? "/og-image-en.png" : "/og-image.png";
    const ogImage = `${SITE.canonicalBase}${ogImagePath}`;
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta(
      "property",
      "og:image:alt",
      lang === "fr"
        ? "Congo Bourse — Innovation & Technologie (MouyIA)"
        : "Congo Bourse — Innovation & Technology (MouyIA)"
    );
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:image", ogImage);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setCanonical(url);
  }, [title, description, path, lang]);
}
